import { render, staticRenderFns } from "./StockOrderCreateButton.vue?vue&type=template&id=24e9c473&"
import script from "./StockOrderCreateButton.vue?vue&type=script&lang=js&"
export * from "./StockOrderCreateButton.vue?vue&type=script&lang=js&"
import style0 from "./StockOrderCreateButton.vue?vue&type=style&index=0&id=24e9c473&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports